import { render, staticRenderFns } from "./Microphone.vue?vue&type=template&id=f1585bee&"
import script from "./Microphone.vue?vue&type=script&lang=js&"
export * from "./Microphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports